module.exports = __webpack_public_path__ + "img/default_paved.b7e24922.png";